import { render, staticRenderFns } from "./AjaxResetPasswordToken.vue?vue&type=template&id=6ae2eec4"
import script from "./AjaxResetPasswordToken.vue?vue&type=script&lang=js"
export * from "./AjaxResetPasswordToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports